/**
 * QuotationStatusService
 * Service for QuotationStatus entity operations
 * Route: api/quotationstatus
 * Controller: QuotationStatusController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * QuotationStatusService
 * Handles quotation status CRUD operations
 * Maps to /api/quotationstatus endpoint
 */
export class QuotationStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? QuotationStatusService.DEFAULT_SERVICE_PATH,
            basePath: QuotationStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
QuotationStatusService.DEFAULT_SERVICE_PATH = 'procurements';
QuotationStatusService.BASE_PATH = 'api/quotationstatus';
//# sourceMappingURL=QuotationStatusService.js.map